import SignUp from '../../src/components/SignUp/SignUp';

const signUpComp = () => <SignUp refer />;

export default signUpComp;
